export default __webpack_public_path__ + "static/city-dcb7355809fe392806afb4cf4f10635c.png";